import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-frost-berry text-frost-vanilla pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <SafeIcon icon="FiWind" className="text-3xl text-frost-ice" />
              <span className="font-serif text-2xl font-bold">FrostBox</span>
            </div>
            <p className="text-frost-ice-dark max-w-sm mb-6">
              Premium frozen desserts delivered to your door. Our cold-chain guarantee ensures your sweet treats arrive perfectly frozen.
            </p>
            <div className="flex gap-4">
              {['FiInstagram', 'FiTwitter', 'FiFacebook'].map((icon, i) => (
                <a key={i} href="#" className="p-2 bg-frost-berry-light rounded-full hover:bg-frost-ice hover:text-frost-berry transition-colors">
                  <SafeIcon icon={icon} className="text-lg" />
                </a>
              ))}
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-bold text-frost-ice mb-4">Shop</h4>
            <ul className="space-y-2 text-frost-ice-dark">
              <li><a href="#" className="hover:text-white transition-colors">Flavor Flights</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Gift Boxes</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Party Bundles</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Corporate Gifting</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-bold text-frost-ice mb-4">Support</h4>
            <ul className="space-y-2 text-frost-ice-dark">
              <li><a href="#" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Shipping & Returns</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Dry Ice Safety</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contact Us</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-frost-berry-light pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-frost-ice-dark">
          <p>&copy; {new Date().getFullYear()} FrostBox Desserts. All rights reserved.</p>
          <p className="text-center" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;